import { Component } from '@angular/core';

import { BaseConfigFormComponent } from '../base/base-config-form.component';
import { ConfigDialogPage, DLG_NAME_POLICY_PAUSE } from '../base/base-config-data';
import { LicenseScopeType } from '../../license/license.data';
import { PolicyType } from '../../../../app/content/setting/policy/policy.data';
import { HelperLib } from '../../../../app/lib/common/helper.lib';
import { IAPIRx } from '../../../../app/API/api.base';

@Component({
    templateUrl: '../base/base-config-form.component.html',
    styleUrls: ['../base/base-config-form.component.css'],
    standalone: false
})
export class PolicyPauseFormComponent extends BaseConfigFormComponent {

    ngOnInit(): void {
        this._dialogName = DLG_NAME_POLICY_PAUSE;
        this._licenseScopeType = LicenseScopeType.all;
        this._policyLockType = PolicyType.Security;
        
        super.ngOnInit();
    }

    protected goNext(fromPage?: ConfigDialogPage): void {
        super.goNext(fromPage);
    }

    protected submit(): void {
        super.submit();

        if (!this._actionData.deviceList[0]?.virtualId) {
            this._page++;
            this._errorMessage = 'Invalid virtualDeviceID';
            return;
        }

        this.naSvc.pauseVirtualDeviceShadow({ virtualDeviceID: this._actionData.deviceList[0]?.virtualId }, this._actionData.pauseDuration * 60, this.accountSvc.token).subscribe((res: IAPIRx<any>) => {
            this._page++;
            if (res.error !== 0) {
                this._errorMessage = HelperLib.getErrorMessage(res);
            }

            if (this.dialogCompleteHandler) {
                this.dialogCompleteHandler(res.data);
            }
        });
    }
}